import { ComplexValue } from 'ui';
import { AttributeMappingType } from './constants';
import { LayoutAttributes } from './types';

export const mapOptionsToLayoutAttributes = (options: ComplexValue<any>[],
  mapping: AttributeMappingType): { [key: string]: string | boolean } => {
  return {
    ...(!!mapping.hideHeader && {
      [mapping.hideHeader]: !options.some(o => o.value === LayoutAttributes.fieldLabels)
    }),
    ...(!!mapping.hideAggrColumns && {
      [mapping.hideAggrColumns]: !options.some(o => o.value === LayoutAttributes.quantities)
    }),
    ...(!!mapping.compactView && {
      [mapping.compactView]: options.some(o => o.value === LayoutAttributes.groups)
    }),
    ...(!!mapping.suppressRepeatingRows && {
      [mapping.suppressRepeatingRows]: options.some(o => o.value === LayoutAttributes.suppressRepeatingRows)
    }),
    ...(!!mapping.wideLayout && {
      [mapping.wideLayout]: options.some(o => o.value === LayoutAttributes.wideLayout)
    }),
    ...(!!mapping.hideTotals && {
      [mapping.hideTotals]: !options.some(o => o.value === LayoutAttributes.totals)
    }),
    ...(!!mapping.xAxisLabelsEnabled && {
      [mapping.xAxisLabelsEnabled]: options.some(o => o.value === LayoutAttributes.xAxisLabelsEnabled)
    }),
    ...(!!mapping.yAxisLabelsEnabled && {
      [mapping.yAxisLabelsEnabled]: options.some(o => o.value === LayoutAttributes.yAxisLabelsEnabled)
    })
  };
};
